class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 250);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      // A hash-only navigation (e.g. an href="#" link) fires popstate with no
      // state; the query string is unchanged, so there is nothing to re-render.
      if (!event.state && window.location.search.slice(1) === FacetFiltersForm.searchParamsPrev) return;
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log(searchParams);
    console.log(document.querySelector('meta[name="robots"]'));
    document.querySelector('meta[name="robots"]').setAttribute('content', 'noindex,nofollow');
    FacetFiltersForm.searchParamsPrev = searchParams;
    // Responses can arrive out of order (e.g. rapidly toggling one option); only
    // the most recent request may render, otherwise a slower, older response
    // overwrites the grid and counts for a filter state that is no longer active.
    const requestId = ++FacetFiltersForm.renderRequestId;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
      if (countContainer.dataset.countTemplate) countContainer.classList.add('js-count-pending');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
      if (countContainerDesktop.dataset.countTemplate) countContainerDesktop.classList.add('js-count-pending');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, searchParams) :
        FacetFiltersForm.renderSectionFromFetch(url, event, requestId, searchParams);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, requestId, searchParams) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        if (requestId !== FacetFiltersForm.renderRequestId) return;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html, searchParams);
        if (window.FacetValueCount) window.FacetValueCount.init();
        if (window.yotpoWidgetsContainer) {
          window.yotpoWidgetsContainer.initWidgets()
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event, searchParams) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html, searchParams);
    if (window.FacetValueCount) window.FacetValueCount.init();
  }

    static loadMoreProducts(url, productGridContainer) {
        //console.log(url);
        console.log(productGridContainer);
        const productGridUl = productGridContainer.querySelector('#product-grid');
        const load_more_btn = productGridContainer.querySelector('.load-more_btn');
        const load_more_progress_bar = productGridContainer.querySelector('.load-more_progress-bar');
        console.log(load_more_btn);
        const load_more_spinner = productGridContainer.querySelector('.load-more_spinner');
        console.log(load_more_spinner);
        const products_loaded_count = productGridContainer.querySelector('.loaded_count');
        load_more_btn.style.display = 'none';
        load_more_progress_bar.style.display = 'none';
        load_more_spinner.style.display = 'block';

        const existing_products = productGridUl.getElementsByClassName('grid__item');
        let existing_products_ids = [];
        if(existing_products) {
            for (let i = 0; i < existing_products.length; i++) {
                existing_products_ids.push(existing_products[i].getAttribute('data-id'));
            }
        }
        console.log(existing_products_ids);
        fetch(url)
            .then(response => response.text())
            .then(nextPage => {
                const parser = new DOMParser();
                const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

                console.log(nextPageDoc);

                load_more_spinner.style.display = 'none';

                const productgrid = nextPageDoc.getElementById('product-grid');
                const new_products = productgrid.getElementsByClassName('grid__item');
                console.log(new_products.length);
                //console.log(new_products_ids);
                const new_url = productgrid.dataset.nextUrl;
                console.log(new_url);
                if (new_url) {
                    load_more_btn.style.display = 'block';
                    load_more_progress_bar.style.display = 'block';
                }
                //next_url = new_url;
                productGridUl.setAttribute('data-next-url', new_url);
                console.log(productGridUl.getAttribute('data-next-url'));
                for (let i = 0; i < new_products.length; i++) {
                    console.log(new_products[i].getAttribute('data-id'));
                    console.log(productGridUl.querySelector('.grid__item[data-id="'+new_products[i].getAttribute('data-id')+'"]'));
                    const newItemId = new_products[i].getAttribute('data-id');
                if(!productGridUl.querySelector('.grid__item[data-id="'+newItemId+'"]')){
                        let single_product = new_products[i].cloneNode(true);
                        productGridUl.appendChild(single_product);
                    }
                }

                if (window.VariantPriceSort) window.VariantPriceSort.sort(productGridUl);

                const totalCountElement = document.querySelector('.total_count');
                const total_product_count = parseInt(
                  totalCountElement?.dataset.variantCardTotal || totalCountElement?.innerHTML || '0',
                  10
                );
                console.log(total_product_count);
                const loaded_product_count = window.VariantCardCount
                  ? VariantCardCount.countGridItems(document)
                  : productGridContainer.querySelectorAll('.grid__item.product__item').length;
                console.log(loaded_product_count);
                console.log(((loaded_product_count/total_product_count)*100) + '%');
                if (window.VariantCardCount) {
                  VariantCardCount.updateLoadedElements(loaded_product_count, total_product_count);
                } else {
                  products_loaded_count.innerHTML = productGridUl.querySelectorAll('.grid__item.product__item').length;
                  document.querySelector('.load-more_progress-bar .progress-value').style.width = ((loaded_product_count/total_product_count)*100) + '%';
                }
                if (window.yotpoWidgetsContainer) {
                  window.yotpoWidgetsContainer.initWidgets()
                }
            }); 

    }

    static loadMoreBtnClick(btnSelector, containerSelector){
        // The grid container is re-rendered on every sort/filter change and this
        // is called each time, so bind the document listener only once or each
        // click would fire one duplicate fetch per earlier render. The listener
        // resolves the live container at click time.
        if (FacetFiltersForm.loadMoreClickBound) return;
        FacetFiltersForm.loadMoreClickBound = true;
        document.addEventListener('click', (ev) => {
            if(ev.target.classList.contains("load-more_btn")){
                // The button is an <a href="#">: without this the click also
                // navigates to "#" and jumps the page back to the top.
                ev.preventDefault();
                const liveContainer = ev.target.closest('#ProductGridContainer');
                if (!liveContainer) return;
                let next_url = liveContainer.querySelector('ul').dataset.nextUrl;
                FacetFiltersForm.loadMoreProducts(next_url, liveContainer);
            }
        });
    }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    let productGridContainer = document.getElementById('ProductGridContainer');
    if (window.VariantPriceSort) {
      window.VariantPriceSort.sort(productGridContainer.querySelector('#product-grid'));
    }
    if (window.collectionInfiniteScroll?.refreshElements) {
      window.collectionInfiniteScroll.refreshElements();
    }
    //new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    const loadMoreBtn = productGridContainer.querySelector('.load-more_btn');
    if (loadMoreBtn) {
      if(productGridContainer.querySelector('#product-grid').getAttribute('data-next-url') == ''){
        loadMoreBtn.style.display = "none";
      } else{
        loadMoreBtn.style.display = "block";
        FacetFiltersForm.loadMoreBtnClick(loadMoreBtn, productGridContainer);
      }
    }
  }

  static renderProductCount(html, searchParams) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const parsedGrid = parsedHTML.getElementById('product-grid');
    const filteredCount = window.VariantCardCount
      ? VariantCardCount.countGridItems(parsedHTML)
      : parsedHTML.querySelectorAll('#product-grid .grid__item.product__item').length;
    const count = parsedHTML.getElementById('ProductCount')?.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const filteredTotalCount = document.querySelector('.total_count');
    const filteredPageCount = document.querySelector('.loaded_count');
    const liveGrid = document.getElementById('product-grid');

    if (liveGrid && parsedGrid) {
      liveGrid.dataset.variantCardTotal = parsedGrid.dataset.variantCardTotal || '';
      liveGrid.dataset.variantCardTotalPending = parsedGrid.dataset.variantCardTotalPending || 'false';
      liveGrid.dataset.showVariantsAsCards = parsedGrid.dataset.showVariantsAsCards || 'false';
    }

    if (filteredTotalCount && parsedGrid?.dataset.variantCardTotal) {
      filteredTotalCount.innerHTML = parsedGrid.dataset.variantCardTotal;
      filteredTotalCount.dataset.variantCardTotal = parsedGrid.dataset.variantCardTotal;
    }

    const refreshVariantCounts = () => {
      if (window.VariantCardCount && liveGrid?.dataset.showVariantsAsCards === 'true') {
        // Key the count to the filter state this markup was rendered for, not
        // window.location, which may already have moved on to a newer state.
        const stateUrl = typeof searchParams === 'string'
          ? `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`
          : undefined;
        VariantCardCount.refreshCounts(liveGrid, { url: stateUrl });
      } else if (filteredPageCount) {
        filteredPageCount.innerHTML = filteredCount;
      }
    };

    const parsedProductCount = parsedHTML.getElementById('ProductCount');
    const parsedProductCountDesktop = parsedHTML.getElementById('ProductCountDesktop');

    if (!count || !container) {
      refreshVariantCounts();
      return;
    }

    if (parsedProductCount?.dataset.countTemplate) {
      container.dataset.countTemplate = parsedProductCount.dataset.countTemplate;
    }

    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      if (parsedProductCountDesktop?.dataset.countTemplate) {
        containerDesktop.dataset.countTemplate = parsedProductCountDesktop.dataset.countTemplate;
      }
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    // Run after the server-rendered count is written (and the count templates
    // are updated) so the resolved variant-card total is never overwritten by
    // the product-level number from the fetched markup.
    refreshVariantCounts();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const target = event.target.closest('.js-filter');
      FacetFiltersForm.renderCounts(countsToRender, target);
      FacetFiltersForm.renderCheckboxCounts(countsToRender, target);
    }

    // Only the very first page load should hide a stale product-level count
    // behind the fade while the real card total resolves. This render is
    // already a live filter update, so let the number swap in place once
    // resolved instead of fading it out again.
    document.querySelectorAll('.facet-checkbox-count.js-count-pending').forEach((element) => {
      element.classList.remove('js-count-pending');
    });
  }

  // The actively-toggled filter group's own markup is intentionally left alone
  // above (skipped by facetsToRender) so its open/checked state doesn't jump
  // under the user's click. But that also freezes its per-value counts and
  // data-count-url — refresh just those, in place, from the freshly fetched HTML.
  static renderCheckboxCounts(source, target) {
    source.querySelectorAll('label[for]').forEach((sourceLabel) => {
      const sourceCount = sourceLabel.querySelector('.facet-checkbox-count');
      if (!sourceCount) return;

      const targetLabel = target.querySelector(`label[for="${sourceLabel.getAttribute('for')}"]`);
      const targetCount = targetLabel?.querySelector('.facet-checkbox-count');
      if (!targetCount) return;

      if (sourceCount.dataset.countUrl) {
        targetCount.dataset.countUrl = sourceCount.dataset.countUrl;
      } else {
        delete targetCount.dataset.countUrl;
      }
      targetCount.textContent = sourceCount.textContent;
      targetCount.classList.toggle('js-count-pending', sourceCount.classList.contains('js-count-pending'));
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.renderRequestId = 0;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
